import { ErrortostringPipe } from './errortostring.pipe';

export default [
    ErrortostringPipe
]
export * from './errortostring.pipe';